import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import App from './App.vue'
import router from './router'
import { useUserStore } from '@/stores'
import './styles/global.scss'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(ElementPlus)

// 刷新后恢复登录态
const token = localStorage.getItem('access_token')
if (token) {
  const userStore = useUserStore()
  userStore.fetchMe().catch(() => {
    // Token 失效，清除状态，由路由守卫处理跳转
    userStore.logout()
  })
}

app.mount('#app')
